/**
 * Safely communicates with Android WebView interface
 * Replaces unsafe eval() usage with type-safe function calls
 */

declare global {
  interface Window {
    Android?: {
      receiveMessage: (message: string) => void;
    };
  }
}

/**
 * Sends a message to Android WebView if available
 * @param payload - The message payload to send
 */
export function sendToAndroid(payload: any): void {
  try {
    if (typeof window !== 'undefined' && window.Android && typeof window.Android.receiveMessage === 'function') {
      const message = typeof payload === 'string' ? payload : JSON.stringify(payload);
      window.Android.receiveMessage(message);
    }
  } catch (error) {
    console.error('Failed to send message to Android:', error);
  }
}
